import React from 'react';
import { Logo, Icon, Avatar, Badge } from './UI';
import { useApp } from '../context/AppContext';

export default function Nav({ activeTab, setActiveTab }) {
  const { user, logout, data } = useApp();

  const studentTabs = [
    { id: 'Home', icon: 'home' },
    { id: 'My Programmes', icon: 'book' },
    { id: 'Inbox', icon: 'inbox' },
  ];
  const adminTabs = [
    { id: 'Home', icon: 'home' },
    { id: 'Programmes', icon: 'book' },
    { id: 'Students', icon: 'users' },
    { id: 'Email', icon: 'mail' },
    { id: 'Stats', icon: 'chart' },
    { id: 'Audit Log', icon: 'eye' },
  ];

  const tabs = user.role === 'admin' ? adminTabs : studentTabs;

  const unreadCount = user.role === 'student'
    ? data.emails.filter(e => e.to.includes(user.id) && !e.read[user.id]).length
    : 0;

  return (
    <nav style={{ background: 'var(--white)', borderBottom: '1px solid var(--dark-10)', position: 'sticky', top: 0, zIndex: 100 }}>
      <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 28px', display: 'flex', alignItems: 'center', height: 66 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginRight: 20 }}>
          <Logo />
          <div style={{ width: 1, height: 28, background: 'var(--dark-20)' }} />
          <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--dark-40)', letterSpacing: '0.1em', textTransform: 'uppercase', fontFamily: 'var(--font-heading)', whiteSpace: 'nowrap' }}>
            {user.role === 'admin' ? 'Admin Portal' : 'Learning Hub'}
          </span>
        </div>

        <div style={{ flex: 1, display: 'flex', gap: 2 }}>
          {tabs.map(tab => {
            const isActive = activeTab === tab.id;
            const hasUnread = tab.id === 'Inbox' && unreadCount > 0;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  fontFamily: 'var(--font-heading)', fontSize: 14,
                  fontWeight: isActive ? 700 : 500,
                  padding: '7px 14px', borderRadius: 'var(--radius-md)',
                  border: 'none', cursor: 'pointer',
                  background: isActive ? 'var(--dark)' : 'transparent',
                  color: isActive ? 'white' : 'var(--dark-60)',
                  display: 'flex', alignItems: 'center', gap: 7,
                  transition: 'all 0.15s', position: 'relative',
                }}
              >
                <Icon name={tab.icon} size={15} color={isActive ? 'white' : 'var(--dark-60)'} />
                {tab.id}
                {hasUnread && (
                  <span style={{ background: 'var(--orange)', color: 'white', fontSize: 10, fontWeight: 700, borderRadius: 99, padding: '1px 6px', lineHeight: 1.6 }}>{unreadCount}</span>
                )}
              </button>
            );
          })}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {user.role === 'admin' && (
            <Badge bg="var(--orange-soft)" color="var(--orange)">Admin</Badge>
          )}
          <Avatar name={user.name} size={36} />
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: 14, fontWeight: 600, color: 'var(--dark)' }}>{user.name.split(' ')[0]}</span>
          <button
            onClick={logout}
            title="Sign out"
            style={{ background: 'var(--dark-05)', border: 'none', width: 34, height: 34, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--dark-60)', transition: 'background 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--dark-10)'}
            onMouseLeave={e => e.currentTarget.style.background = 'var(--dark-05)'}
          >
            <Icon name="logout" size={16} />
          </button>
        </div>
      </div>
    </nav>
  );
}
